import type { EligibilityCheckView } from '../dispatch.api';

/** Ant tag colour for a check: an overridden block reads as a warning, since it still happened and someone answered for it. */
export function tagColourOf(check: EligibilityCheckView): 'success' | 'warning' | 'error' {
  if (check.override) return 'warning';
  if (check.status === 'block') return 'error';
  return check.status === 'warn' ? 'warning' : 'success';
}
